const normalizeCountry = (country) =>
  String(country ?? '')
    .trim()
    .replace(/\u0130/g, 'I')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/\u0131/g, 'i')
    .replace(/\u03c2/g, '\u03c3')
    .replace(/[^a-z0-9\u0370-\u03ff]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^the /, '');

const CYPRUS_COUNTRIES = new Set(
  [
    'Cyprus',
    'Republic of Cyprus',
    'Republican Cyprus',
    'Κύπρος',
    'Kıbrıs',
    'CY',
    'CYP',
  ].map(normalizeCountry)
);

export const isCyprusCountry = (country) =>
  CYPRUS_COUNTRIES.has(normalizeCountry(country));

export const hasEuVatNumber = (euVatNumber) =>
  typeof euVatNumber === 'string' && euVatNumber.trim() !== '';

// Cyprus is always gross. Outside Cyprus, an EU VAT number selects net.
// A missing company cannot qualify for net, so the payable amount is gross.
export const shouldChargeGross = (company) => {
  if (!company || isCyprusCountry(company.country)) return true;
  return !hasEuVatNumber(company.eu_vat_number);
};
